"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardSchema = void 0;
const ECategoriesCards_1 = require("./ECategoriesCards");
const ETypeCards_1 = require("./ETypeCards");
const zod_1 = require("zod");
const CardSchema = zod_1.z.object({
    id: zod_1.z.number(),
    title: zod_1.z.string(),
    type: zod_1.z.nativeEnum(ETypeCards_1.ETypeCards),
    category: zod_1.z.nativeEnum(ECategoriesCards_1.ECategoriesCards),
    difficulty: zod_1.z.number(),
    textPlayer: zod_1.z.string(),
    textAnimator: zod_1.z.string(),
    version: zod_1.z.number(),
    comment: zod_1.z.string(),
    typeSpecificContent: zod_1.z.string(),
    short_description: zod_1.z.string(),
    reference: zod_1.z.string(),
    is_kept_card: zod_1.z.boolean(),
    isAnswerCorrect: zod_1.z.boolean(),
    isSelected: zod_1.z.boolean(),
});
exports.CardSchema = CardSchema;
